"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ptCompanyNumberChecker = void 0;
var NIF_REGEX = /^[1-9]\d{8}$/;
var NIF_LENGTH = 8;

/**
 * Calculates the weighted sum of a string value based on the MOD11 algorithm.
 * The mod 11 algorithm calculates a check digit by summing the weighted digits of a number
 * (typically from right to left with decreasing weights) and taking the modulus 11 of the sum,
 * ensuring validation or integrity.
 *
 * @param {string} companyNumber - The string value
 * @returns {number} The calculated weighted sum of the string value.
 */
var calculateWeightedSum = function calculateWeightedSum(companyNumber) {
  var weightedSum = 0;
  for (var i = 0; i < NIF_LENGTH; i += 1) {
    weightedSum += (9 - i) * parseInt(companyNumber[i], 10);
  }
  return weightedSum;
};
var ptCompanyNumberChecker = exports.ptCompanyNumberChecker = function ptCompanyNumberChecker(companyNumber) {
  if (!NIF_REGEX.test(companyNumber)) {
    return false;
  }
  var weightedSum = calculateWeightedSum(companyNumber);
  var remainder = weightedSum % 11;
  var checkDigit = remainder <= 1 ? 0 : 11 - remainder;
  return checkDigit === parseInt(companyNumber[NIF_LENGTH], 10);
};